<script setup lang="ts">
import { useKeyTranslation } from '@/composables/useKeyTranslation'
import { formatDate } from '@/helpers/formating'
import chip from '@/assets/icons/chip.svg'
import { useStore } from 'vuex'
import { computed } from 'vue'

const store = useStore()

const { translateKey } = useKeyTranslation()
const isMobile = computed(() => store.getters.globals_mobile)

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const isAmountNegative = computed(() => {
  const amount = String(props?.item?.amount).trim()
  return amount.startsWith('-')
})
</script>

<template>
  <div class="item">
    <div
      class="d-flex flex-row ga-4"
      style="flex-wrap: wrap"
    >
      <div class="arrow-block">
        <div class="arrow">
          <i
            :class="`mdi ${isAmountNegative ? 'mdi-arrow-down' : 'mdi-arrow-up'} text-large`"
            :style="{
              color: !isAmountNegative
                ? 'var(--palette-primary-main)'
                : 'var(--palette-text-secondary)',
            }"
          ></i>

          <component
            :is="chip"
            class="chip"
          />
        </div>
        <span
          v-if="isMobile"
          class="credit"
        >
          {{
            $t('user_settings.credits_current_balance_value', {
              credits_balance: Math.floor(Number(item.amount)).toLocaleString(),
            })
          }}
        </span>
      </div>
      <div class="d-flex flex-column justify-center">
        <span style="font: var(--font-subtitle3); font-weight: bold">{{
          translateKey(item.name, 'user_settings.transaction_types')
        }}</span>
        <span style="color: var(--palette-text-secondary)">
          {{ item.description }}
        </span>
      </div>
    </div>

    <div
      class="d-flex flex-column text-right justify-space-between"
      :class="{ 'flex-row-reverse': isMobile }"
    >
      <span
        v-if="!isMobile"
        class="credit"
      >
        {{
          $t('user_settings.credits_current_balance_value', {
            credits_balance: Math.floor(Number(item.amount)).toLocaleString(),
          })
        }}
      </span>
      <span
        class="date"
        style="color: var(--clr-grey-2)"
        >{{ formatDate(item.date_created, { customFormat: 'yyyy-MMM-dd' }) }}</span
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.arrow {
  width: 48px;
  height: 48px;
  background-color: var(--palette-paper-elevation4);
  color: var(--palette-text-secondary);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.chip {
  color: var(--palette-text-secondary);
  position: absolute;
  width: 18px;
  height: 18px;
  bottom: 0;
  right: 0;
}

.item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 1rem;
  margin: 0 1rem 0 1rem;
  background: #161618;
  padding: 1rem;
  border-radius: 0.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}
.credit {
  font: var(--font-subtitle2);
}

.date {
  font: var(--font-body2);
}

.arrow-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

@media (max-width: 1024px) {
  .arrow-block {
    flex-direction: row;
    width: 100%;
  }

  .arrow {
    width: 32px;
    height: 32px;
  }

  .chip {
    width: 12px;
    height: 12px;
  }

  .credit {
    font: var(--font-subtitle3);
    font-weight: 600;
  }

  .date {
    font: var(--font-body3);
  }
}
</style>
